import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';

import {
  CardInfo,
  CardInfoTitle,
  CardInfoFieldWrapper,
  CardInfoField,
} from '../sharedStyles';
import { formatCNPJ } from '../../../../utils/format';

interface IFranchisees {
  code: string;
  name: string;
  cnpj: string;
  ie: string;
  email: string;
  address: {
    streetName: string;
    number: string;
    complement: string;
    neighborhood: string;
    zipCode: string;
    city: string;
    uf: string;
  };
  phones: string[];
}

export const Cards = (): JSX.Element => {
  const stateStep1 = useSelector(
    (state: ApplicationState) => state.openClaim.step.step1,
  );

  const [franchisees, setFranchisees] = useState<IFranchisees>();

  useEffect(() => {
    if (stateStep1) {
      setFranchisees(stateStep1.lojas.data);
    }
  }, [stateStep1, franchisees]);

  return (
    <>
      {franchisees && (
        <>
          <CardInfo>
            <CardInfoTitle>Confira os dados da loja</CardInfoTitle>
            <CardInfoFieldWrapper>
              <CardInfoField flex={3}>
                <span>Loja/Franquia</span>
                {franchisees?.name}
              </CardInfoField>
              <CardInfoField flex={1}>
                <span>Código PDV</span>
                {franchisees?.code}
              </CardInfoField>
              <CardInfoField flex={2}>
                <span>CNPJ</span>
                {formatCNPJ(franchisees?.cnpj)}
              </CardInfoField>
            </CardInfoFieldWrapper>
          </CardInfo>

          <CardInfo>
            <CardInfoTitle>Confira o endereço da ocorrência</CardInfoTitle>
            <CardInfoFieldWrapper>
              <CardInfoField flex={3}>
                <span>CEP</span>
                {franchisees?.address?.zipCode}
              </CardInfoField>
              <CardInfoField flex={1}>
                <span>Estado</span>
                {franchisees?.address?.uf}
              </CardInfoField>
              <CardInfoField flex={2}>
                <span>Cidade</span>
                {franchisees?.address?.city}
              </CardInfoField>
            </CardInfoFieldWrapper>
            <CardInfoFieldWrapper>
              <CardInfoField flex={3}>
                <span>Logradouro</span>
                {franchisees?.address?.streetName}
              </CardInfoField>
              <CardInfoField flex={1}>
                <span>Número</span>
                {franchisees?.address?.number}
              </CardInfoField>
              <CardInfoField flex={2}>
                <span>Complemento</span>
                {franchisees?.address?.complement}
              </CardInfoField>
            </CardInfoFieldWrapper>
          </CardInfo>
        </>
      )}
    </>
  );
};
